export function formatCurrency(val) {
  return Math.max(0, val).toFixed(0).replace(/(?=(?:\d{3})+$)(?!^)/g, '.');
}